/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
export * from './breakpoints/data/break-points';
export * from './breakpoints/data/orientation-break-points';
export * from './breakpoints/break-points-token';
export * from './breakpoints/break-point-registry';
export * from './observable-media';
export * from './match-media';
export * from './media-change';
export * from './media-monitor';
export * from './breakpoints/break-points-provider';
export * from './observable-media-provider';
export * from './media-monitor-provider';
export * from './_module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/~/@angular/flex-layout/media-query/index.js
// module id = ../../../flex-layout/media-query/index.js
// module chunks = 3